export const ASK_GREG_DEFAULTS = {
  TITLE: "Can't find what you're looking for? Ask Greg.",
  DESCRIPTION:
    'Let our smart assistant help you locate the right file, recommend documents for your project, and find what you need faster.',
  QUICK_PROMPTS_TITLE: 'You could try these quick prompts',
};

export const DEFAULT_QUICK_PROMPTS = [
  { text: 'What is STRUCTApanel® made of?' },
  { text: 'How do I install STRUCTAflor®?' },
  { text: 'Is your timber graded to Australian Standards?' },
];
